/**
 * Client-specific tracking adaptations.
 */
window.WSHOP_TRACKER = window.WSHOP_TRACKER || {};

const allowedSet = new Set([
    "context",
    "consent",
    "event",
    "get",
    "js",
    "config",
    "order",
    "landing_page",
    "login",
    "sign_up",
    "newsletter_submit",
    "compte_invite_inscription_etape_connexion",
    "tunnel_etape_connexion_invite",
    "social_connect",
    "search",
    "storeLocator",
    "filter_interaction",
    "store_locator",
    "delivery_type_seen",
    "delivery_type_click",
    "view_item_list",
    "select_item",
    "view_item",
    "add_to_wishlist",
    "add_to_cart",
    "view_cart",
    "remove_from_cart",
    "begin_checkout",
    "add_shipping_info",
    "add_payment_info",
    "purchase",
    "checkout",
    "registrationComplete",
    "compte_invite_inscription_etape_confirmation",
    "find_storeLocator_click",
    "social_connect",
    "share_cart",
    "product_stock_display_updated"
]);

const payloadNormalizers = {
    context: (payload) => normalizeContextPayload(payload),
    order: (payload) => normalizeContextPayload(payload),
    default: (payload) => payload
};

function isAllowedEvent(eventName) {
    return allowedSet.has(eventName);
}

function normalizePayload(event) {
    const normalize = payloadNormalizers[event.name] || payloadNormalizers.default;

    return normalize(event.payload, event);
}

function transformPayload(payload) {
    return transformEcommerceItemsIdToSku(payload);
}

function isObject(value) {
    return value && typeof value === "object" && !Array.isArray(value);
}

function extractPageContextPayload(payload) {
    if (!isObject(payload)) return {};
    if (isObject(payload.context)) return payload;

    return {};
}

function getCookieValue(name) {
    if (typeof document === "undefined" || typeof document.cookie !== "string") return "";

    const cookies = document.cookie ? document.cookie.split(";") : [];
    const prefix = `${name}=`;

    for (let i = 0; i < cookies.length; i += 1) {
        const cookie = cookies[i].trim();
        if (!cookie.startsWith(prefix)) continue;

        return decodeURIComponent(cookie.slice(prefix.length));
    }

    return "";
}

function applyNavFunnelContext(contextPayload) {
    const checkoutCategories = ["delivery", "cart", "bank_index", "purchase"];
    const routeId = contextPayload?.context?.page?.id;
    const categoryPage = contextPayload?.context?.page?.category;

    const isCheckoutContext =
        routeId === "order_identification"
        || checkoutCategories.includes(categoryPage);

    if (!isCheckoutContext) return;

    let navFunnel = "Other";

    if (getCookieValue("nav_funnel") === "Global-E") {
        navFunnel = "Global-E";
    }

    contextPayload.context.nav_funnel = navFunnel;
}

function transformPlatformEnvValue(payload) {
    const contextPayload = extractPageContextPayload(payload);
    const platformEnv = contextPayload?.context?.navigation?.platform_env;

    if (typeof platformEnv !== "string") return;

    const normalizedPlatformEnv = platformEnv.trim().toLowerCase();
    contextPayload.context.navigation.platform_env =
        normalizedPlatformEnv === "prod" ? "Production" : "Preproduction";
}

function normalizeContextPayload(payload) {
    const contextPayload = extractPageContextPayload(payload);
    if (!isObject(contextPayload.context)) return payload;

    transformPlatformEnvValue(payload);
    applyNavFunnelContext(contextPayload);

    return payload;
}

const clientConfig = {
  eventProcess(event) {
    if (!isAllowedEvent(event.name)) return false;

    const normalized = normalizePayload(event);
    const payload = transformPayload(normalized);

    return { ...event, payload };
  }
};

if (typeof WSHOP_TRACKER.setClientConfig === "function") {
    WSHOP_TRACKER.setClientConfig(clientConfig);
} else {
    WSHOP_TRACKER.clientConfig = {
        ...(WSHOP_TRACKER.clientConfig || {}),
        ...clientConfig
    };
}

/**
 * Transforms items: sets item_id to item_sku and removes item_sku.
 */
function transformEcommerceItemsIdToSku(payload) {
    if (!payload?.ecommerce?.items || !Array.isArray(payload.ecommerce.items)) {
        return payload;
    }

    const items = payload.ecommerce.items.map((item) => {
        // 1. Destructure to extract item_sku and item_id
        // 2. By not including item_sku in the return, it is removed
        const { item_sku, item_id, ...rest } = item;
        return {
            ...rest,
            // 3. Assign item_sku value to the item_id key
            item_id: item_sku || item_id
        };
    });

    return {
        ...payload,
        ecommerce: {
            ...payload.ecommerce,
            items
        }
    };
}